import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import { useState, useEffect, FormEvent } from "react";
import React from "react";
import {
  defaultPersonalDevelopment,
  IGender,
  IPersonalDevelopment,
} from "../../../shared/models/PersonalDevelopment";
import MODAL_NAMES from "../ModalName";
import { hideModalFromId } from "../../../shared/functions/ModalShow";

const UpdatePersonalDevelopmentModal = observer(() => {
  const { store, api } = useAppContext();
  const me = store.auth.me?.asJson;
  const [personalDev, setPersonalDev] = useState<IPersonalDevelopment>({
    ...defaultPersonalDevelopment,
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Load the selected personal development item into the state when the modal opens
    if (store.personalDevelopment.selected) {
      setPersonalDev(store.personalDevelopment.selected);
    }
  }, [store.personalDevelopment.selected]);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("clicked");

    // Check if the user has a UID and supervisor
    if (me?.uid && me?.supervisor) {
      // Define the currentProfile before the try block
      const currentProfile: IPersonalDevelopment = {
        ...personalDev,
        uid: me.uid,
        dateCreated: Date.now(),
        supervisorId: me.supervisor,
        type: "Profile",
      };

      setLoading(true);
      try {
        if (store.personalDevelopment.selected && personalDev.uid!=="" ) {
          // Update functionality
          console.log("In");

          await api.personalDevelopment.update(currentProfile);
        } else {
          // Create functionality
          console.log(" creating api");
          
          await api.personalDevelopment.create(currentProfile); // Change to currentProfile
        }
      } catch (error) {
        console.error("Error updating personal development:", error);
      } finally {
        setLoading(false);
        onCancel();
      }
    }
  };

  const onCancel = () => {
    // Clear the selected item and reset the form state
    store.personalDevelopment.clearSelected();
    setPersonalDev(defaultPersonalDevelopment);
    hideModalFromId(MODAL_NAMES.EXECUTION.PERSONAL_DEVELOPMENT_UPDATE_MODAL);
  };

  return (
    <div className="personal-development-modal uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
      <button
        className="uk-modal-close-default"
        type="button"
        data-uk-close
      ></button>

      <h3 className="uk-modal-title">Update Personal Development</h3>

      <div className="dialog-content uk-position-relative">
        <form
          className="uk-form-stacked uk-grid-small"
          data-uk-grid
          onSubmit={handleSubmit}
        >
          {/* Define Your Career Goals */}
          <div className="uk-width-1-1">
            <label>Define Your Career Goals</label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="Define your career goals"
              value={personalDev.careerGoals}
              onChange={(e) =>
                setPersonalDev({ ...personalDev, careerGoals: e.target.value })
              }
            />

            {/* Skill Development */}
            <label className="uk-margin-top">Skill Development</label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="Describe your skill development plan"
              value={personalDev.skillDevelopment}
              onChange={(e) =>
                setPersonalDev({
                  ...personalDev,
                  skillDevelopment: e.target.value,
                })
              }
            />

            {/* Improvement Areas */}
            <label className="uk-margin-top">Improvement Areas</label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="List your improvement areas"
              value={personalDev.improvementAreas}
              onChange={(e) =>
                setPersonalDev({
                  ...personalDev,
                  improvementAreas: e.target.value,
                })
              }
            />

            {/* Action Items */}
            <label className="uk-margin-top">Action Items</label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="Define actionable steps"
              value={personalDev.actionItems}
              onChange={(e) =>
                setPersonalDev({ ...personalDev, actionItems: e.target.value })
              }
            />

            {/* Leadership & Values */}
            <label className="uk-margin-top">Leadership & Values</label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="Define your leadership values"
              value={personalDev.leadershipValues}
              onChange={(e) =>
                setPersonalDev({
                  ...personalDev,
                  leadershipValues: e.target.value,
                })
              }
            />

            {/* Skill Improvement and Development Actions */}
            <label className="uk-margin-top">
              Skill Improvement and Development Actions
            </label>
            <textarea
              className="uk-textarea uk-margin-small-top"
              rows={3}
              placeholder="Outline skill improvement actions"
              value={personalDev.skillImprovement}
              onChange={(e) =>
                setPersonalDev({
                  ...personalDev,
                  skillImprovement: e.target.value,
                })
              }
            />
            <label className="uk-margin-top">Gender</label>
            <select
              className="uk-select uk-margin-small-top"
              value={personalDev.gender}
              onChange={(e) =>
                setPersonalDev({
                  ...personalDev,
                  gender: e.target.value as IGender, // Cast the value to `IGender`
                })
              }
            >
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
          </div>

          {/* Button Section */}
          <div className="uk-width-1-1 uk-text-right">
            <button
              className="btn-text uk-margin-right"
              type="button"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
            >
              Update {loading && <div data-uk-spinner="ratio: .5"></div>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default UpdatePersonalDevelopmentModal;
